<template>
    <v-col
        :cols="width"
    >
        <v-label v-if="item.props.label">{{item.props.label}}</v-label>
        <!-- If the row property is set, render horizontally -->
        <v-row v-if="item.props.row" >
            <v-col
                :key="`checkboxlist-${thisItem.value}-${index}`"
                cols="4"
                class="justify-space-between"
                v-for="(thisItem, index) in item.props.items"
            >
                <v-checkbox
                    :key="thisItem.value + index"
                    :label="thisItem.text"
                    :disabled="readonly || item.props.readonly"
                    hide-details
                    color="primary"
                    v-model="modelData[thisItem.value]"
                    v-on:change="handleChange(thisItem.value, $event)"
                />
                <template v-if="item.props.withDescription" v-slot:label>
                    <div v-html="thisItem.text"></div>
                </template>

                <template v-if="item.props.tooltip" v-slot:append>
                    <v-tooltip
                        top
                    >
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-information</v-icon>
                        </template>
                        <div v-html="item.props.tooltip"></div>
                    </v-tooltip>
                </template>
            </v-col>
        </v-row>

        <!-- row property is not set, render vertically -->
        <template v-else>
            <v-checkbox
                :key="thisItem.value + index"
                :label="thisItem.text"
                :disabled="readonly || item.props.readonly"
                hide-details
                color="primary"
                v-for="(thisItem, index) in item.props.items"
                v-model="modelData[thisItem.value]"
                v-on:change="handleChange(thisItem.value, $event)"
                :class="item.props.withDescription ? 'my-2 py-2' : 'my-2 py-0'"
            >
                <template v-if="item.props.withDescription" v-slot:label>
                    <div v-html="thisItem.text"></div>
                </template>
                <template v-if="thisItem.props && thisItem.props.indent" v-slot:prepend>
                    <div style="width: 20px"></div>
                </template>
                <template v-else-if="item.props.tooltip" v-slot:append>
                    <v-tooltip
                        top
                    >
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-information</v-icon>
                        </template>
                        {{item.props.tooltip}}
                    </v-tooltip>
                </template>
            </v-checkbox>
        </template>
        <v-input
            :rules="rules"
            :value="modelData"
            class="secret-input"
            ref="input"
        />
    </v-col>
</template>
<script>
    export default {
        name: 'CheckboxList',
        props: ['item', 'value', 'readonly', 'rules', 'optional', 'width'],
        computed: {
            modelData: function () {
                return this.value || {};
            }
        },
        methods: {
            handleChange: function (name, value) {
                const checkboxValues = Object.assign(
                    {},
                    this.value,
                    {
                        [name]: value
                    }
                );

                this.$emit('input', checkboxValues);
            },
            validate: function () {
                return this.$refs.input.validate();
            }
        }
    }
</script>

<style scoped>
    >>>.v-input__slot {
        align-items: start !important;
        /* justify-content: start !important; */
    }
</style>


// WEBPACK FOOTER //
// src/components/questionnaire_template/checkbox-list.vue